import React from 'react';
import { Link } from 'react-router-dom';

export default function ThankYou() {
    return (
        <section id="ThankYou" className="thankyou--section">
            <div className="hero--section--content--box about--section--box">
                <h1 className="skills-section--heading">Thank You</h1>
                <p className="hero--section-description">Your Message Has Been Sent. 
                <br/>
                We appreciate your message. Our team will get back to you soon.
                </p>
                <Link to="/" className="btn btn-primary">Back to Home</Link>
            </div>
        </section>
    );
}
